import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  header: {
    marginHorizontal: 20,
    marginVertical: 20,
    paddingVertical: 20,
    paddingHorizontal: 10,
    borderRadius: 20,
    elevation: 4,
    backgroundColor: 'white',
  },
});
